import { getMonth, lightFormat as format } from 'date-fns';
import { useMemo } from 'react';
import { getDays, GetDaysProps, getWeekdayLabels, GetWeekdayLabelsProps } from './useMonth.utils';

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const monthLabelFormatFn = (date: Date) => months[getMonth(date)] + format(date, ' yyyy');
export const onlyMonthLabelFormatFn = (date: Date) => months[getMonth(date)];
export const onlyYearLabelFormatFn = (date: Date) => format(date, ' yyyy');

export interface UseMonthResult {
  weekdayLabels: string[];
  days: (number | { dayLabel: string; date: Date })[];
  monthLabel: string;
}

export interface UseMonthProps extends GetWeekdayLabelsProps, GetDaysProps {
  monthLabelFormat?(date: Date): string;
}

export function useMonth({
  year,
  month,
  firstDayOfWeek = 1,
  dayLabelFormat,
  weekdayLabelFormat,
  monthLabelFormat = monthLabelFormatFn
}: UseMonthProps): UseMonthResult {
  const days = useMemo(() => getDays({ year, month, firstDayOfWeek, dayLabelFormat }), [
    year,
    month,
    firstDayOfWeek,
    dayLabelFormat
  ]);
  const weekdayLabels = useMemo(() => getWeekdayLabels({ firstDayOfWeek, weekdayLabelFormat }), [
    firstDayOfWeek,
    weekdayLabelFormat
  ]);

  return {
    days,
    weekdayLabels,
    monthLabel: monthLabelFormat(new Date(year, month))
  };
}
